<div class="status__content">
	<p>
		<span>No SSR</span>
	</p>
</div>
